import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getWishList } from '../redux/actions/productActions';
import { globalStatistic } from '../redux/actions/otherActions';
import styles from '../css/Wishlist.module.css';

import WishListItem from '../components/other/WishListItem';
import WishListButtonRemoveAll from '../components/other/WishListButtonRemoveAll';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import queryString from 'query-string';
import axios from 'axios';


const XmlShareComponent = () => {
    const location = useLocation();

    useEffect(() => {
        const parsedParams = queryString.parse(location.search);
        const queryParams = new URLSearchParams(parsedParams).toString();
        window.location.href = `https://newb2b.ewe.rs:5006/share?${queryParams}`;
    }, [location.search]);

    return null; // Ne prikazujemo ništa jer preusmeravamo korisnika
}

export default XmlShareComponent;